export default {
  "common.brand": "US Fans Spreadsheet",
  "common.tagline": "Independent fan merch resource",
  "common.buyNow": "Buy Now",
  "common.visitStore": "Visit Store",
  "common.guide": "Guide",
  "common.home": "Home",
  "common.shoppingGuide": "Shopping Guide",
  "common.menu": "Menu",
  "common.selectCategory": "Choose a category…",
  "common.browseCategories": "Browse Categories",
  "common.readMore": "Read more",
  "common.external": "Opens in a new tab",
  "common.backHome": "Back to home",
  "lang.en": "English",
  "lang.es": "Español",
  "lang.fr": "Français",
  "lang.pl": "Polski",
  "footer.tagline": "An independent hub organizing fan merchandise into easy-to-browse categories.",
  "footer.resources": "Resources",
  "footer.categories": "Categories",
  "footer.guide": "Fan Merch Guide",
  "footer.visitStore": "Visit the main store",
  "footer.disclaimer": "US Fans Spreadsheet is an independent information resource and is not affiliated with or endorsed by any official brand or team.",
  "footer.rights": "All rights reserved.",
};